module.exports = __webpack_public_path__ + "static/media/centro_cancha_1(1).62d92eb1.jpg";